/**
 * Date helpers (PT-PT).
 */
export const PT_MONTHS = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];
export const PT_DAYS_SHORT = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
export const PT_DAYS_FULL = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];

export function fmtDate(d) {
    if (!d) return "—";
    const dt = typeof d === "string" ? new Date(d) : d;
    if (isNaN(dt.getTime())) return "—";
    return dt.toLocaleDateString("pt-PT", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
}

export function fmtDateTime(d) {
    if (!d) return "—";
    const dt = typeof d === "string" ? new Date(d) : d;
    if (isNaN(dt.getTime())) return "—";
    return dt.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}

export function fmtTime(d) {
    if (!d) return "—";
    const dt = typeof d === "string" ? new Date(d) : d;
    if (isNaN(dt.getTime())) return "—";
    return dt.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" });
}

export function relativeFromNow(d) {
    if (!d) return "—";
    const dt = typeof d === "string" ? new Date(d) : d;
    const diff = dt.getTime() - Date.now();
    const abs = Math.abs(diff);
    const min = Math.round(abs / 60000);
    if (min < 1) return "agora";
    if (min < 60) return diff > 0 ? `em ${min}m` : `há ${min}m`;
    const h = Math.round(min / 60);
    if (h < 24) return diff > 0 ? `em ${h}h` : `há ${h}h`;
    const d2 = Math.round(h / 24);
    return diff > 0 ? `em ${d2}d` : `há ${d2}d`;
}

export function startOfMonth(year, month) {
    return new Date(year, month, 1);
}
export function endOfMonth(year, month) {
    return new Date(year, month + 1, 0);
}
export function daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}
